import { GtmDimensions, GtmEventNames } from 'google-tag-manager';
import { pushToDataLayer } from './utils/helpers';

export const pushGtmStartAnalyticsData = () => {
  const startData = {
    [GtmDimensions.start]: new Date().getTime(),
    [GtmDimensions.event]: GtmEventNames.gtmJs
  };
  pushToDataLayer(startData);
};
